<template>
    <b-container fluid class="pt-4">
        <b-row>
            <b-col>
                <div id="chart-container" class="text-center"></div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import OrgChart from 'orgchart.js';
import Organisation from '@/services/Organisation/Organisation';
import { forEach } from 'lodash';

export default {
  name: 'Organisation-Chart',
  components: {},
  data() {
    return {
      loading: false,
      chartData: [],
      nodeContent: 'users',
      orgchart: null,
    };
  },
  watch: {
    '$store.getters.userClientName': function (newVal) {
      this.refreshData()
    }
  },
  created() {
    this.getChartData();
  },
  methods: {
    async refreshData () {
      await this.getChartData()
    },
    async getChartData() {
      this.loading = true;

      const { data } = await Organisation.get();
      const { organisation } = data;

      this.chartData = this.formatData(organisation);

      this.createChart();
      this.loading = false;
    },
    createChart() {
      let container = document.getElementById('chart-container')
      container.innerHTML = ''

      this.orgchart = new OrgChart({
        chartContainer: '#chart-container',
        data: this.chartData,
        nodeTitle: 'value',
        nodeContent: 'users',
      });
    },
    formatData(data) {
      const format = (object) => {
        const formattedData = [];
        forEach(object, (obj) => {
          const { children, users } = obj;

          if (children) {
            obj.children = format(children);
          }

          if (obj.children.length === 0) {
            delete obj.children;
          }

          if (users) {
            obj.users = users
              .map(user => `${user.user.firstName} ${user.user.lastName}`)
              .join('</br>');
          }

          formattedData.push(obj);
        });

        return formattedData;
      };

      // Add client as root
      const client = this.$store.getters.userClientName;
      const chart = format(data);

      return {
        children: chart,
        value: client,
        users: '',
      };
    },
  },
};
</script>
<style lang="scss">
@import '~orgchart.js/src/orgchart.css';

.jumbotron.sm {
    padding: 1rem 1.5rem;
}

#chart-container {
    overflow: auto;
    max-height: 88vh;
}

.orgchart {
    width: auto;
    background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.15) 10%, rgba(0, 0, 0, 0) 10%), linear-gradient(rgba(0,
            0, 0, 0.15) 10%, rgba(0, 0, 0, 0) 10%);

    tr.lines {
        .topLine,
        .rightLine,
        .leftLine,
        .downLine {
            border-color: $primary;
        }

        .downLine {
            background-color: $primary;
        }
    }

    .node {
        .title {
            background-color: $primary;
        }

        .content {
            border-color: $border-color;
            height: auto;
        }
    }

}
</style>
